
import { dealCategories } from '../../../mocks/deals';

interface CategoryFilterProps {
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

export default function CategoryFilter({
  activeCategory,
  onCategoryChange,
}: CategoryFilterProps) {
  return (
    <section className="py-6 border-b border-gray-100 bg-white sticky top-[72px] z-40">
      <div className="max-w-7xl mx-auto px-6">
        <div
          className="flex items-center gap-3 overflow-x-auto pb-1"
          style={{
            /* Hide scrollbar in Firefox & IE/Edge */
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
          }}
        >
          {dealCategories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => onCategoryChange(cat.id)}
              className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                activeCategory === cat.id
                  ? 'bg-teal-600 text-white shadow-sm'
                  : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
              }`}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${cat.icon} text-base`}></i>
              </div>
              {cat.name}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
